<template>
    <el-dialog
        title="报名管理"
        :visible.sync="dialogSign"
        width="1320px" :close-on-click-modal="false">
        <div class="toolLeft">
            <div class="orderSearchBox">
                <el-input v-model="teamName" placeholder="单位/院校"></el-input>
                <el-input v-model="account" placeholder="账号"></el-input>
                <!--<el-date-picker
                    clearable
                    v-model="signDate"
                    type="date"
                    placeholder="报名时间"
                >
                </el-date-picker>-->
                <el-select v-model="signType" placeholder="参赛主体">
                    <el-option label="个人" value="PERSONAL"></el-option>
                    <el-option label="团体" value="TEAM"></el-option>
                </el-select>
                <el-date-picker
                    style="width:320px"
                    @change="chooseDate"
                    v-model="signDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="报名开始日期"
                    end-placeholder="报名结束日期">
                </el-date-picker>
                <el-select v-model="worksStatus" placeholder="作品上传">
                    <el-option label="已上传" value="TRUE"></el-option>
                    <el-option label="未上传" value="FALSE"></el-option>
                </el-select>
                <el-select v-model="activityWayUuid" placeholder="赛道名称">
                    <el-option v-for="(item,index) in activityWayList" :key="index"
                               :label="item.name"
                               :value="item.uuid"></el-option>
                </el-select>
                <el-button class="searchBtn" @click="searchSignInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
          <span
            >已选： <span class="num">{{ num }}</span></span
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="publishSubmit('')"
            >批量导出</el-button
          >
            <el-button
                type="primary"
                plain
                size="small"
                @click="exportAllData('')"
            >全部导出</el-button
            >
        </div>
        <div class="orderListTable">
            <el-table
                height="520"
                :data="tableData"
                border
                @selection-change="handleSelectionChange"
                style="width: 100%" class="tableContent">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="报名时间"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="姓名"
                    header-align="center"
                    show-overflow-tooltip
                    width="120"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="nickName"
                    label="昵称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="account"
                    label="账号"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="tel"
                    align="center"
                    header-align="center"
                    label="联系电话"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="signTypeCn"
                    align="center"
                    header-align="center"
                    label="参赛主体" width="100">
                </el-table-column>
                <el-table-column
                    prop="teamName"
                    align="center"
                    header-align="center"
                    label="单位/院校" width="200">
                </el-table-column>
                <el-table-column
                    prop="teamMember"
                    align="center"
                    header-align="center"
                    label="指导老师" width="200">
                </el-table-column>
                <el-table-column
                    prop="worksUuid"
                    align="center"
                    header-align="center"
                    label="作品上传" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.worksNum===0?'未上传':'已上传' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="activityWayName"
                    align="center"
                    header-align="center"
                    label="赛道名称" width="150">
                </el-table-column>
                <!-- <el-table-column
                    label="操作"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small">导出</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <el-pagination
                class="curren"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>

</template>

<script>
import { getSignList,getAllSignList,getActivityWayList } from '../../../utils/interface';
export default {
    name: "signDialog",
    data() {
        return{
            dialogSign: false,
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            activityUuid:'',
            num:0,
            teamName:"",
            account:"",
            signDate:null,
            multipleSelection:[],
            activityWayList:[],
            signType:"",
            worksStatus:null,
            activityWayUuid:"",
            startTime:"",
            endTime:"",
        }
    },
    methods: {
        resetData(){
            this.teamName = '';
            this.account = '';
            this.signDate = null;
            this.signType = "";
            this.worksStatus = null;
            this.activityWayUuid = "";
            this.startTime = "";
            this.endTime = "";
            this.getSignList();
        },
        init(type,uuid) {
            this.tableData = [];
            this.activityUuid = uuid;
            this.dialogSign = true;
            // 根据活动查询列表
            this.getSignList();
            // 查询赛道
            this.getActivityWayList();
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.signDate!=null && this.signDate.length==2){
                this.startTime = this.timeDate(this.signDate[0]);
                this.endTime = this.timeDate(this.signDate[1]);
            }
        },
        getActivityWayList(){
            getActivityWayList({activityUuid:this.activityUuid}).then((res)=>{
                this.activityWayList = res;
            });
        },
        getSignList(){
            //let year = this.signDate==null?null:this.signDate.getFullYear();
            //let month = this.signDate==null?null:this.signDate.getMonth() < 10?'0'+(this.signDate.getMonth() + 1):this.signDate.getMonth() + 1;
            //let date = this.signDate==null?null:this.signDate.getDate() < 10?'0'+this.signDate.getDate():this.signDate.getDate();
            let params = {
                teamName:this.teamName,
                account:this.account,
                signType:this.signType,
                worksStatus:this.worksStatus,
                activityWayUuid:this.activityWayUuid,
                activityUuid:this.activityUuid,
                signStartDate:this.startTime,
                signEndDate:this.endTime,
                current:this.current,
                pageSize:this.pageSize,
                //signDate:this.signDate==null?null:year+"-"+month+"-"+date,
            };
            getSignList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
                this.tableData.map(item=>{
                   if(item.worksNum==0){
                       this.$set(item, 'uploadName', '未上传');
                   }else{
                       this.$set(item, 'uploadName', '已上传');
                   }
                });
            });
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getSignList();
        },
        searchSignInfo(){
            this.current = 1;
            this.getSignList();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.num = this.multipleSelection.length;
        },
        // 批量导出
        publishSubmit(){
            if(this.multipleSelection.length==0){
                this.$message.error("请选择要导出的数据");
                return
            }
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../../../static/js/Export2Excel');//注意这个Export2Excel路径
                const tHeader = ['报名时间', '姓名', '账号', '昵称', '联系方式', '参赛主体',
                    '单位/院校', '指导老师', '作品上传', '赛道名称'];   // 上面设置Excel的表格第一行的标题
                const filterVal = ['createTime', 'name', 'account', 'nickName', 'tel',
                    'signTypeCn', 'teamName', 'teamMember', 'uploadName', 'activityWayName']; // 上面的index、nickName、name是tableData里对象的属性key值
                const list = this.multipleSelection;  //把要导出的数据tableData存到list
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, this.multipleSelection[0].activityName+'-报名管理');//最后一个是表名字
            })
        },
        // 全部导出
        exportAllData(){
            // 如果有查询条件，就查询所有的数据，如果没有查询条件就是所有的数据
            let params = {
                teamName:this.teamName,
                account:this.account,
                signType:this.signType,
                worksStatus:this.worksStatus,
                activityWayUuid:this.activityWayUuid,
                activityUuid:this.activityUuid,
                signStartDate:this.startTime,
                signEndDate:this.endTime,
            };
            getAllSignList(params).then((res)=>{
                res.map(item=>{
                    if(item.worksUuid==null){
                        this.$set(item, 'uploadName', '未上传');
                    }else{
                        this.$set(item, 'uploadName', '已上传');
                    }
                });
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../../static/js/Export2Excel');//注意这个Export2Excel路径
                    const tHeader = ['报名时间', '姓名', '账号', '昵称', '联系方式', '参赛主体',
                        '单位/院校', '团体成员', '作品上传', '赛道名称'];   // 上面设置Excel的表格第一行的标题
                    const filterVal = ['createTime', 'name', 'account', 'nickName', 'tel',
                        'signTypeCn', 'teamName', 'teamMember', 'uploadName', 'activityWayName']; // 上面的index、nickName、name是tableData里对象的属性key值
                    const data = this.formatJson(filterVal, res);
                    export_json_to_excel(tHeader, data, res[0].activityName+'-报名管理');//最后一个是表名字
                })
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        }
    }
}
</script>

<style scoped lang="less">
.toolLeft {
  margin-bottom: 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.847);

  .num {
    color: #356fdf;
  }

  button {
    padding: 0;
    margin-left: 15px;
    width: 80px;
    height: 30px;
    background: rgba(242, 244, 247, 1);
    box-sizing: border-box;
    border: 1px solid rgba(21, 126, 251, 1);
    border-radius: 5px;
    font-size: 12px;
    color: #157efb;
    line-height: 30px;
    text-align: center;

    &:hover {
      background: #157efb;
      box-sizing: border-box;
      border: 1px solid #157efb;
      color: #fff;
    }
  }
}
.orderListTable {
  .curren {
    margin-top: 20px;
    text-align: right;

  }
}
.orderSearchBox {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
    }

    .resetBtn {
        background: #fff;
        border: none;
        color: #333333;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/signDialog.vue